import { render, staticRenderFns } from "./PortalNodeCreate.vue?vue&type=template&id=23ad0dc2"
import script from "./PortalNodeCreate.ts?vue&type=script&lang=ts"
export * from "./PortalNodeCreate.ts?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.0.10@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports